import { Document, Page, View, StyleSheet, Text, Image, Font } from "@react-pdf/renderer";
import imgKkp from '../../../assets/images/logo_kkp.jpg'
import imgttde from '../../../assets/images/ttde.jpg'
import srcArial from '../../../assets/custom/font/arial/arial.ttf'
import srcArialBold from '../../../assets/custom/font/arial/ARIBL0.ttf'
import srcRobotoBoldItalic from '../../../assets/custom/font/roboto/Roboto-BoldItalic.ttf'
import srcRobotoItalic from '../../../assets/custom/font/roboto/Roboto-Italic.ttf'
import { cekBerlakuSertifikatByUpt, formatDateStringLocalDateINA, formatDateStringLocalDateUS } from "../../../utilities/Utils";
import imgGaruda from '../../../assets/images/pngwing.png';

Font.register({ family: 'Arial', src: srcArial })
Font.register({ family: 'Arial-Bold', src: srcArialBold })
Font.register({ family: 'Roboto-Italic', src: srcRobotoItalic })
Font.register({ family: 'Roboto-BoldItalic', src: srcRobotoBoldItalic })

const styles = StyleSheet.create({
    page: {
        paddingTop: 20,
        paddingBottom: 48,
        paddingHorizontal: 42,
        boxSizing: "border-box"
    },
    headingImg: {
        width: 65,
        height: 65,
        marginVertical: 15,
        marginHorizontal: 230,
    },
    headingTtd: {
        width: 200,
        height: 60,
    },
    table: {
        display: "table",
        width: "auto"
    },
    tableRow: {
        flexDirection: "row",
        flexWrap: "wrap"
    },
    tableCol: {
        borderWidth: 0,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        padding: 1
    },
    text: {
        fontSize: 10,
        fontFamily: "Arial"
    },
    textBold: {
        fontSize: 10,
        fontFamily: "Arial-Bold"
    },
    textIn: {
        fontSize: 10,
        fontFamily: "Roboto-Italic"
    },
    textInBold: {
        fontSize: 10,
        fontFamily: "Roboto-BoldItalic"
    },
    background: {
        position: 'absolute',
        top: '35%',
        left: '25%',
        width: 350,
        opacity: 0.1,
    },
})

const SertCPIBKapal = ({ dataDisposisi, dataPpmKapal, isUnder5GT, dataInspeksi, dataSert, jenisKomoditi, jenisKomoditiEn, uptData }) => {

    return (
        <Document>
            <Page size="A4" style={styles.page} wrap={false}>
                <Image
                    src={imgKkp}
                    style={styles.background}
                    fixed
                />

                <View style={[styles.table, { alignItems: 'center' }]}>
                    <View style={[styles.tableRow]}>
                        <View style={[styles.tableCol, { justifyContent: 'center' }]}>
                            <Image style={[styles.headingImg]} src={imgGaruda} />
                        </View>
                    </View>
                </View>
                <View style={[styles.table, { marginBottom: 5 }]}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '100%', alignItems: 'center' }]}>
                            <Text style={[styles.textBold, { fontSize: 10, textAlign: 'center' }]}>KEMENTERIAN KELAUTAN DAN PERIKANAN</Text>
                            <Text style={[styles.textBold, { fontSize: 10, textDecoration: 'underline', textAlign: 'center' }]}>BADAN PENGENDALIAN DAN PENGAWASAN MUTU HASIL KELAUTAN DAN PERIKANAN</Text>
                            <Text style={[styles.textInBold, { textAlign: 'center' }]}>Ministry of Marine Affairs and Fisheries</Text>
                            <Text style={[styles.textInBold, { textAlign: 'center' }]}>Marine and Fisheries Quality Assurance Agency</Text>
                        </View>
                    </View>
                </View>
                <View style={[styles.table, { marginBottom: 5 }]}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '100%', alignItems: 'center' }]}>
                            <Text style={[styles.textBold, { fontSize: 10, textDecoration: 'underline', textAlign: 'center' }]}>SERTIFIKAT CARA PENANGANAN IKAN YANG BAIK</Text>
                            <Text style={[styles.textInBold, { textAlign: 'center' }]}>GOOD HANDLING PRACTICES CERTIFICATE</Text>
                        </View>
                    </View>
                </View>
                <View style={[styles.table]}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '100%', alignItems: 'center' }]}>
                            <Text style={[styles.textBold, { fontSize: 11, textAlign: 'center' }]}>Nomor: {dataSert && dataSert.nomorSertifikat}</Text>
                        </View>
                    </View>
                </View>
                <View style={[styles.table, { paddingTop: 5, paddingBottom: 5 }]}>
                    <View style={[styles.tableRow]}>
                        <View style={[styles.tableCol, { width: '100%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left', textDecoration: 'underline' }]}>Berdasarkan Peraturan Menteri Kelautan dan Perikanan Nomor 10 Tahun 2021 tentang Standar Kegiatan Usaha dan Produk pada Penyelenggaraan Perizinan Berusaha Berbasis Risiko sektor Kelautan dan Perikanan</Text>
                            <Text style={[styles.textIn, { textAlign: 'left' }]}>Based on Having regards to the Regulation of the Minister of Marine Affairs and Fisheries Republic of Indonesia No. 10 of 2021 laying down Standard for Business Activities in the Implementation of Risk-Based Business Licensing in the Marine and Fisheries sector</Text>
                        </View>
                    </View>
                </View>
                <View style={[styles.table, { paddingBottom: 5 }]}>
                    <View style={[styles.tableRow]}>
                        <View style={[styles.tableCol, { width: '100%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left', textDecoration: 'underline' }]}>menetapkan bahwa</Text>
                            <Text style={[styles.textIn, { textAlign: 'left' }]}>to certify that</Text>
                        </View>
                    </View>
                </View>
                <View style={[styles.table]}>
                    <View style={[styles.tableRow, { paddingLeft: 25, paddingRight: 15 }]}>
                        <View style={[styles.tableCol, { width: '30%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textDecoration: 'underline', textAlign: 'left' }]}>Kapal Perikanan</Text>
                            <Text style={[styles.textIn, { textAlign: 'left' }]}>Fishing Vessel</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>:</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '64%' }]}>
                            <Text style={[styles.textBold, { fontSize: 10, textAlign: 'left' }]}>{dataPpmKapal && dataPpmKapal.namaKapal}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '30%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textDecoration: 'underline', textAlign: 'left' }]}>Alamat</Text>
                            <Text style={[styles.textIn, { textAlign: 'left' }]}>Address</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>:</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '64%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>{dataSert && dataSert.alamatPemilik}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '30%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textDecoration: 'underline', textAlign: 'left' }]}>Ukuran Kapal</Text>
                            <Text style={[styles.textIn, { textAlign: 'left' }]}>Size of fishing vessel</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>:</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '64%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>{dataPpmKapal && dataPpmKapal.ukuranKapal} GT</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '30%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textDecoration: 'underline', textAlign: 'left' }]}>Tipe Kapal</Text>
                            <Text style={[styles.textIn, { textAlign: 'left' }]}>Type of fishing vessel</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>:</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '64%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textDecoration: 'underline', textAlign: 'left' }]}>{dataPpmKapal && (dataPpmKapal.jenisKapal === '1' ? 'Kapal Penangkap' : 'Kapal Pengangkut')}</Text>
                            <Text style={[styles.textIn, { fontSize: 10, textAlign: 'left' }]}>{dataPpmKapal && (dataPpmKapal.jenisKapal === '1' ? 'Fishing Vessel' : 'Collecting Vessel')}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '30%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textDecoration: 'underline', textAlign: 'left' }]}>Tanggal Inspeksi</Text>
                            <Text style={[styles.textIn, { textAlign: 'left' }]}>Inspection date</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>:</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '64%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textDecoration: 'underline', textAlign: 'left' }]}>{dataInspeksi && formatDateStringLocalDateINA(dataInspeksi.tglInspeksi)}</Text>
                            <Text style={[styles.textIn, { fontSize: 10, textAlign: 'left' }]}>{dataInspeksi && formatDateStringLocalDateUS(dataInspeksi.tglInspeksi)}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '30%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textDecoration: 'underline', textAlign: 'left' }]}>Jenis Produk</Text>
                            <Text style={[styles.textIn, { textAlign: 'left' }]}>Commodity</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>:</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '64%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textDecoration: 'underline', textAlign: 'left' }]}>
                                {jenisKomoditi && jenisKomoditi.map((kmd, index) => {
                                    return <>{kmd}{index < jenisKomoditi.length - 1 && ', '}</>
                                })}
                            </Text>
                            <Text style={[styles.textIn, { fontSize: 10, textAlign: 'left' }]}>
                                {jenisKomoditiEn && jenisKomoditiEn.map((kmdEn, index) => {
                                    return <>{kmdEn}{index < jenisKomoditiEn.length - 1 && ', '}</>
                                })}
                            </Text>
                        </View>
                        {
                            isUnder5GT && isUnder5GT === 'T' &&
                            <>
                                <View style={[styles.tableCol, { width: '30%' }]}>
                                    <Text style={[styles.text, { fontSize: 10, textDecoration: 'underline', textAlign: 'left' }]}>Pemeringkatan</Text>
                                    <Text style={[styles.textIn, { textAlign: 'left' }]}>Grade</Text>
                                </View>
                                <View style={[styles.tableCol, { width: '3%' }]}>
                                    <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>:</Text>
                                </View>
                                <View style={[styles.tableCol, { width: '64%' }]}>
                                    <Text style={[styles.textBold, { fontSize: 10, textAlign: 'left' }]}>{dataSert && dataSert.grade}</Text>
                                </View>
                            </>
                        }
                    </View>
                </View>
                <View style={[styles.table, { paddingTop: 5, paddingBottom: 5 }]}>
                    <View style={[styles.tableRow]}>
                        <View style={[styles.tableCol, { width: '100%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'center', textDecoration: 'underline' }]}>Dinyatakan telah memenuhi persyaratan Cara Penanganan Ikan yang Baik</Text>
                            <Text style={[styles.textIn, { textAlign: 'center' }]}>Is declared to have fulfilled in Good Handling Practice requirements</Text>
                        </View>
                    </View>
                </View>
                <View style={styles.table}>
                    <View style={[styles.tableRow, { marginBottom: 3 }]}>
                        <View style={[styles.tableCol, { width: '60%' }]}>
                            <Text style={[styles.text, { textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableRow, { width: '17%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left', textDecoration: 'underline' }]}>Diterbitkan di</Text>
                            <Text style={[styles.textIn, { textAlign: 'left' }]}>Issued in</Text>
                        </View>
                        <View style={[styles.tableRow, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>:</Text>
                        </View>
                        <View style={[styles.tableRow, { width: '20%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>{cekBerlakuSertifikatByUpt(dataPpmKapal?.tanggalAjuKapal) === 'Y' ? uptData?.kota : 'JAKARTA'}</Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { marginBottom: 3 }]}>
                        <View style={[styles.tableCol, { width: '60%' }]}>
                            <Text style={[styles.text, { textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '17%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left', textDecoration: 'underline' }]}>Pada tanggal</Text>
                            <Text style={[styles.textIn, { textAlign: 'left' }]}>Date</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>:</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '20%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textDecoration: 'underline', textAlign: 'left' }]}>{dataSert && formatDateStringLocalDateINA(dataSert.tanggalTerbit)}</Text>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>{dataSert && formatDateStringLocalDateUS(dataSert.tanggalTerbit)}</Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { marginBottom: 3 }]}>
                        <View style={[styles.tableCol, { width: '60%' }]}>
                            <Text style={[styles.text, { textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '17%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left', textDecoration: 'underline' }]}>Berlaku sampai</Text>
                            <Text style={[styles.textIn, { textAlign: 'left' }]}>Valid until</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>:</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '20%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textDecoration: 'underline', textAlign: 'left' }]}>{dataSert && formatDateStringLocalDateINA(dataSert.berlakuSampai)}</Text>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>{dataSert && formatDateStringLocalDateUS(dataSert.berlakuSampai)}</Text>
                        </View>
                    </View>
                    {
                        cekBerlakuSertifikatByUpt(dataPpmKapal?.tanggalAjuKapal) === 'Y' &&
                        <>
                            <View style={[styles.tableRow, { marginBottom: 3 }]}>
                                <View style={[styles.tableCol, { width: '55%' }]}>
                                    <Text style={[styles.text, { textAlign: 'left' }]}></Text>
                                </View>
                                <View style={[styles.tableCol, { width: '5%' }]}>
                                    <Text style={[styles.text, { fontSize: 10, textAlign: 'left', textDecoration: 'underline' }]}>a.n. </Text>
                                    <Text style={[styles.textIn, { textAlign: 'left' }]}>p.p. </Text>
                                </View>
                                <View style={[styles.tableRow, { width: '30%' }]}>
                                    <Text style={[styles.text, { fontSize: 10, textAlign: 'left', textDecoration: 'underline' }]}>Kepala BPPMHKP</Text>
                                    <Text style={[styles.textIn, { textAlign: 'left' }]}>Director General of MFQAA</Text>
                                </View>
                                <View style={[styles.tableRow, { width: '10%' }]}>
                                    <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}></Text>
                                </View>
                            </View>
                            <View style={[styles.tableRow, { marginBottom: 3 }]}>
                                <View style={[styles.tableCol, { width: '60%' }]}>
                                    <Text style={[styles.text, { textAlign: 'left' }]}></Text>
                                </View>
                                <View style={[styles.tableRow, { width: '35%' }]}>
                                    <Text style={[styles.text, { fontSize: 9, textAlign: 'left', textDecoration: 'underline' }]}>{dataSert?.jabatanTtd}</Text>
                                    <Text style={[styles.textIn, { textAlign: 'left' }]}>Head Of {uptData?.nmInggris}</Text>
                                </View>
                                <View style={[styles.tableRow, { width: '5%' }]}>
                                    <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}></Text>
                                </View>
                            </View>
                        </>
                    }
                    {
                        cekBerlakuSertifikatByUpt(dataPpmKapal?.tanggalAjuKapal) === 'T' &&
                        <View style={[styles.tableRow, { marginBottom: 3 }]}>
                            <View style={[styles.tableCol, { width: '60%' }]}>
                                <Text style={[styles.text, { textAlign: 'left' }]}></Text>
                            </View>
                            <View style={[styles.tableRow, { width: '30%' }]}>
                                <Text style={[styles.text, { fontSize: 10, textAlign: 'left', textDecoration: 'underline' }]}>Kepala BPPMHKP</Text>
                                <Text style={[styles.textIn, { textAlign: 'left' }]}>Director General of MFQAA</Text>
                            </View>
                            <View style={[styles.tableRow, { width: '10%' }]}>
                                <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}></Text>
                            </View>
                        </View>
                    }

                    <View style={[styles.tableRow, { marginBottom: 3 }]}>
                        <View style={[styles.tableCol, { width: '60%' }]}>
                            <Text style={[styles.text, { textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '40%', alignItems: 'center' }]}>
                            <Image style={[styles.headingTtd]} src={imgttde} />
                        </View>
                    </View>
                    <View style={[styles.tableRow, { marginBottom: 3 }]}>
                        <View style={[styles.tableCol, { width: '60%' }]}>
                            <Text style={[styles.text, { textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '30%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>{cekBerlakuSertifikatByUpt(dataPpmKapal?.tanggalAjuKapal) === 'Y' ? dataSert?.namaTtd : 'ISHARTINI'}</Text>
                        </View>
                        <View style={[styles.tableRow, { width: '10%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}></Text>
                        </View>
                    </View>
                </View>
            </Page>
        </Document>
    )
}

export default SertCPIBKapal